var pcbFontPoints = {
    'a' : [[[1.5,9],[6,9],[8.5,7],[8.5,0],[2,0],[0,2.5],[2,5],[8.5,5]]],
    'b' : [[[0,12],[0,0],[6.5,0],[9,2],[9,6.5],[6.5,9],[3,9],[0,6]]],
    'c' : [[[9,6.5],[9,7],[6.5,9],[2.5,9],[0,6.5],[0,2.5],[2.5,0],[6.5,0],[9,2],[9,2.5]]],
    'd' : [[[9,12],[9,0],[2.5,0],[0,2.5],[0,6.5],[2.5,9],[6,9],[9,6]]],
    'e' : [[[8,0],[2.5,0],[0,2.5],[0,6.5],[2.5,9],[6.5,9],[9,6.5],[9,4.5],[0,4.5]]],
    'f' : [[[2,0],[2,10],[4,12],[6,12],[8,10],[8,9.5]],[[0,5],[4,5]]],
    'g' : [[[9,9],[9,-1.5],[7.5,-3],[2.5,-3]],[[9,1],[2,1],[0,3],[0,6.5],[2.5,9],[6,9],[9,6]]],
    'h' : [[[0,0],[0,12]],[[8,0],[8,6.5],[5.5,9],[3,9],[0,6.5]]],
    'i' : [[[1,12],[1,12]],[[0,9],[1,9],[1,0]],[[0,0],[2,0]]],
    'j' : [[[5,12],[5,12]],[[4,9],[5,9],[5,-1.5],[3.5,-3],[1.5,-3],[0,-1.5],[0,0]]],
    'k' : [[[0,0],[0,12]],[[0,1.5],[8,8.5],[8,9]],[[4,5],[8,0.5],[8,0]]],
    'l' : [[[0,12],[2,12],[2,0]],[[0,0],[4,0]]],
    'm' : [[[0,9],[0,0]],[[0,6.5],[2.5,9],[4.5,9],[6,7.5],[6,0]],[[6,7.5],[7,9],[9.5,9],[12,6.5],[12,0]]],
    'n' : [[[0,0],[0,9]],[[0,6],[3,9],[6.5,9],[9,6.5],[9,0]]],
    'o' : [[[0,2.5],[0,6.5],[2.5,9],[6.5,9],[9,6.5],[9,2.5],[6.5,0],[2.5,0],[0,2.5]]],
    'p' : [[[0,-3],[0,9]],[[0,6.5],[2.5,9],[6.5,9],[9,6.5],[9,4],[6.5,1.5],[2.5,1.5],[0,4]]],
    'q' : [[[9,-3],[9,9]],[[9,4],[6.5,1.5],[2.5,1.5],[0,4],[0,6.5],[2.5,9],[6.5,9],[9,6.5]]],
    'r' : [[[0,0],[0,9]],[[0,5],[3.5,9],[7.5,9],[9,7.5],[9,7]]],
    's' : [[[0,2],[0,1.5],[1.5,0],[7.5,0],[9,1.5],[9,3],[7.5,4.5],[1.5,4.5],[0,6],[0,7.5],[1.5,9],[7.5,9],[9,7.5],[9,7]]],
    't' : [[[1.5,12],[1.5,2],[3.5,0],[6.5,0],[8,1.5],[8,2]],[[0,9],[4,9]]],
    'u' : [[[9,9],[9,0]],[[0,9],[0,2.5],[2.5,0],[6.5,0],[9,2.5]]],
    'v' : [[[0,9],[0,4],[4,0],[5,0],[9,4],[9,9]]],
    'w' : [[[0,9],[0,4],[2.5,0],[3.5,0],[6,3],[8.5,0],[9.5,0],[12,4],[12,9]],[[6,4],[6,3]]],
    'x' : [[[0,0],[0,0.5],[9,8.5],[9,9]],[[0,9],[0,8.5],[9,0.5],[9,0]]],
    'y' : [[[9,9],[9,-1.5],[7.5,-3],[2,-3]],[[0,9],[0,3.5],[2,1.5],[9,1.5]]],
    'z' : [[[0,9],[9,9],[9,8.5],[0,0.5],[0,0],[9,0]]],
    'A' : [[[0,0],[0,6],[4,12],[5,12],[9,6],[9,0]],[[0,3],[9,3]]],
    'B' : [[[0,0],[0,12],[7,12],[9,10],[9,8],[7,6],[0,6]],[[7,6],[9,4],[9,2],[7,0],[0,0]]],
    'C' : [[[9,3],[9,2],[7,0],[2,0],[0,2],[0,10],[2,12],[7,12],[9,10],[9,9]]],
    'D' : [[[0,0],[0,12],[7,12],[9,10],[9,2],[7,0],[0,0]]],
    'E' : [[[7,0],[0,0],[0,12],[7,12]],[[6,6],[0,6]]],
    'F' : [[[0,0],[0,12],[7,12]],[[6,6],[0,6]]],
    'G' : [[[5.5,5],[9,5],[9,2],[7,0],[2,0],[0,2],[0,10],[2,12],[7,12],[9,10],[9,9]]],
    'H' : [[[0,0],[0,12]],[[0,6],[8,6]],[[8,0],[8,12]]],
    'I' : [[[1.5,0],[1.5,12]],[[0,0],[3,0]],[[0,12],[3,12]]],
    'J' : [[[0,3],[0,2],[2,0],[5,0],[7,2],[7,12]],[[5,12],[8,12]]],
    'K' : [[[0,0],[0,12]],[[0,4],[8,11.5],[8,12]],[[8,0],[8,0.5],[3,6.5]]],
    'L' : [[[7,0],[0,0],[0,12]]],
    'M' : [[[0,0],[0,12]],[[0,11.5],[5.5,7.5],[11,11.5]],[[11,12],[11,0]]],
    'N' : [[[0,0],[0,12]],[[0,11],[8,3.5]],[[8,0],[8,12]]],
    'O' : [[[2,0],[0,2],[0,10],[2,12],[7,12],[9,10],[9,2],[7,0],[2,0]]],
    'P' : [[[0,0],[0,12],[6,12],[8,10],[8,8],[6,6],[0,6]]],
    'Q' : [[[2,0],[0,2],[0,10],[2,12],[7,12],[9,10],[9,3.5],[5,0],[2,0]],[[5.5,3.5],[9,0]]],
    'R' : [[[0,0],[0,12],[6,12],[8,10],[8,8],[6,6],[0,6]],[[6,6],[8,4],[8,0]]],
    'S' : [[[0,2],[2,0],[7,0],[9,2],[9,4],[7,6],[2,6],[0,8],[0,10],[2,12],[7,12],[9,10]]],
    'T' : [[[4,0],[4,12]],[[0,12],[8,12]]],
    'U' : [[[0,12],[0,1.5],[1.5,0],[6.5,0],[8,1.5],[8,12]]],
    'V' : [[[0,12],[0,5],[4,0],[8,5],[8,12]]],
    'W' : [[[0,12],[0,4],[3,0],[5.5,3],[8,0],[11,4],[11,12]],[[5.5,3],[5.5,6]]],
    'X' : [[[0,0],[0,0.5],[9,11.5],[9,12]],[[0,12],[0,11.5],[9,0.5],[9,0]]],
    'Y' : [[[0,12],[0,11],[4.5,5]],[[4.5,0],[4.5,5],[9,11],[9,12]]],
    'Z' : [[[9,0],[0,0],[0,1],[9,11],[9,12],[0,12]]],
    '0' : [[[1.5,0],[0,1.5],[0,10.5],[1.5,12],[5.5,12],[7,10.5],[7,1.5],[5.5,0],[1.5,0]],[[0,3],[7,9]]],
    '1' : [[[2.5,0],[2.5,12],[1.5,12],[0,10]],[[0,0],[4.5,0]]],
    '2' : [[[0,10],[0,10.5],[1.5,12],[5.5,12],[7,10.5],[7,7],[0,0],[7,0]]],
    '3' : [[[0,10],[0,10.5],[1.5,12],[5.5,12],[7,10.5],[7,8.5],[4.5,6],[7,3.5],[7,1.5],[5.5,0],[1.5,0],[0,1.5],[0,2]],[[3,6],[4.5,6]]],
    '4' : [[[6,0],[6,12],[5,12],[0,4.5],[0,2.5],[7,2.5]]],
    '5' : [[[0,2],[0,1.5],[1.5,0],[5.5,0],[7,1.5],[7,5],[5.5,6.5],[0,6.5],[0,12],[6,12]]],
    '6' : [[[7,10],[7,10.5],[5.5,12],[1.5,12],[0,10.5],[0,1.5],[1.5,0],[5.5,0],[7,1.5],[7,4.5],[5.5,6],[0,6]]],
    '7' : [[[3,0],[3,4],[7,10],[7,12],[0,12]]],
    '8' : [[[5.5,6],[7,4.5],[7,1.5],[5.5,0],[1.5,0],[0,1.5],[0,4.5],[1.5,6],[5.5,6],[7,7.5],[7,10.5],[5.5,12],[1.5,12],[0,10.5],[0,7.5],[1.5,6]]],
    '9' : [[[7,6],[1.5,6],[0,7.5],[0,10.5],[1.5,12],[5.5,12],[7,10.5],[7,1.5],[5.5,0],[1.5,0]]],
    ' ' : [[[0,0],[9,0]]],
    '+' : [[[0,5.2], [7,5.2]], [[3.5,1.65], [3.5,8.75]]], // d="M0,5.2 7,5.2 M3.5,1.65 3.5,8.75"
    '.' : [[[0,0], [0.35,0], [0.35,0.35], [0,0]]], // d="M0,0 0.35,0 0.35,0.35 0,0.35 0,0"
    '-' : [[[0,5.2], [7,5.2]]],
    '<' : [[[5,1], [1,6], [5,11]]], // d="M0,5.2 7,5.2 M3.5,1.65 3.5,8.75"
    '>' : [[[0,0], [7,6], [0,12]]]
};

module.exports = pcbFontPoints;